import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import { ApiResponse } from '../../../../interfaces/models/models/paginated-response.model';
import { PaginatedInvitedPartners, PaginatedPartners } from '../../../../interfaces/partners/paginatedStore.type';
import { IAdminEditPartner } from '../../../../interfaces/partners/IAdminEditPartner';
import { IPartnersSchema } from '../../../../interfaces/partners/IPartnersSchema';
import { IFilterPartners } from '../../../../interfaces/partners/IFilterPartners';
import { IEditPartner } from '../../../../interfaces/partners/IEditPartner';
import { IAddress } from '../../../../interfaces/auth/ICreateUserSchema';
import { IPartners } from '../../../../interfaces/partners/IPartners';

const tryToFetchPartners = (
    pageNumber: number,
    pageSize: number,
    data?: IFilterPartners,
    filters?: string,
): Promise<AxiosResponse<PaginatedPartners>> => {
    const url = filters
        ? `${USERS_API_URL}/partners?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/partners?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedPartners>(url, { filters: data });
};

const tryToFetchInvitedPartners = (
    pageNumber: number,
    pageSize: number,
    data?: IFilterPartners,
    filters?: string,
): Promise<AxiosResponse<PaginatedInvitedPartners>> => {
    const url = filters
        ? `${USERS_API_URL}/partners/registration-request/all?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/partners/registration-request/all?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedInvitedPartners>(url, data);
};

const tryToResendInvitePartner = (payload: any): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/partners/registration-request/resend-link`, payload);
};


const tryToFetchAllPartners = (): Promise<AxiosResponse<IPartners[]>> => {
    return brokersAxios.put(`${USERS_API_URL}/partners?flag=true`);
};

const tryToFetchPartnerNavigation = (): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/users/access-control`);
};

const tryToFetchUserNotifications = (data?: any, page?: number, size?: number): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/notifications?page=${page}&skip=${size}`, data);
};

const tryToSetReadNotifications = (data?: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/notifications/read`, data);
};

const tryToGenerateApiKey = (): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/integration/generate/api-key`);
};

const tryToAddGeneratedApiKey = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/integration/user`, data);
};

const tryToInviteNewPartner = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.post(`${USERS_API_URL}/partners/registration-request`, data);
};

const tryToAuthorizeUser = (data: { dashboard: string; }): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/users/authorization`, data);
};

const tryToAddPartner = (data: IPartners): Promise<AxiosResponse> => {
    return brokersAxios.post(`${USERS_API_URL}/partners`, data);
};

const tryToFetchUserData = (): Promise<AxiosResponse> => {
    return brokersAxios.get(`${USERS_API_URL}/dom/user`);
};

const tryToRequestToRegisterPartner = (data: any): Promise<AxiosResponse> => {
    return brokersAxios.post(`${USERS_API_URL}/dom/partner/registration-request/create`, data);
};

const tryToEnablePartner = (id: string): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/partners/${id}/enable`);
};

const tryToEditPartner = (payload: IEditPartner): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/partners/change-company-info`, payload);
};

const tryToDeletePartner = (partnerId: string): Promise<AxiosResponse<ApiResponse<IPartnersSchema>>> => {
    return brokersAxios.delete(`${USERS_API_URL}/partners/${partnerId}/delete`);
};

const tryToEditPartnerDetails = (partnerId: string, payload: IAdminEditPartner): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/partners/${partnerId}`, payload);
};

const tryToEditAddressPartner = (payload: IAddress): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/partners/change-address/${payload?.id}`, payload);
};

const tryToSetAddressDefault = (id: string): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/partners/set-default-address/${id}`);
};

const tryToDisablePartner = (id: string): Promise<AxiosResponse> => {
    return brokersAxios.delete(`${USERS_API_URL}/partners/${id}`);
};

const tryToFetchSinglePartner = (id: string): Promise<AxiosResponse<ApiResponse<IPartnersSchema>>> => {
    return brokersAxios.get<ApiResponse<any>>(
        `${USERS_API_URL}/partners/${id}`,
    );
};


export const PartnersService = {
    tryToFetchPartners,
    tryToFetchAllPartners,
    tryToFetchSinglePartner,
    tryToAddPartner,
    tryToEditPartner,
    tryToEditPartnerDetails,
    tryToEditAddressPartner,
    tryToSetAddressDefault,
    tryToEnablePartner,
    tryToDisablePartner,
    tryToDeletePartner,
    tryToRequestToRegisterPartner,
    tryToAuthorizeUser,
    tryToFetchPartnerNavigation,
    tryToGenerateApiKey,
    tryToAddGeneratedApiKey,
    tryToFetchUserNotifications,
    tryToSetReadNotifications,
    tryToFetchUserData,
    tryToInviteNewPartner,
    tryToFetchInvitedPartners,
    tryToResendInvitePartner
};
